import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { Row, Col } from "antd"

import { W1 } from "@components"
import { listAllProjectsOperation } from "@api/services/backstage"
import { useAppContext, runRequest } from "@components/AppContext"

import ReportCard from "./ReportCard"
import ProjectsReportModal from "./ProjectsReportModal"
import InvestmentsReportModal from "./InvestmentsReportModal"
import OrganizationsReportModal from "./OrganizationsReportModal"
import DistributionsReportModal from "./DistributionsReportModal"
import FailedDistributionsReportModal from "./FailedDistributionsReportModal"

const LABEL_PROJECTS = "Projects"
const LABEL_INVESTMENTS = "Investments"
const LABEL_ORGANIZATIONS = "Organizations"
const LABEL_DISTRIBUTIONS = "Distributions, Monthly"
const LABEL_FAILED_DISTRIBUTIONS = "Failed Distributions"

const LABEL_PROJECTS_SUMMARY = `Projects with equity raised and total amounts
  distributed for each.`
const LABEL_INVESTMENTS_SUMMARY = `Investments with investor profiles details
  for each portal.`
const LABEL_ORGANIZATIONS_SUMMARY = `Distribution $ amounts for each portal for
  selected date range.`
const LABEL_DISTRIBUTIONS_SUMMARY = `Distributions for each portal project for
  selected month.`
const LABEL_FAILED_DISTRIBUTIONS_SUMMARY = `Failed distributions for each
  portal project.`


const ReportsList = ({
  span = 8
}) => {
  const { authenticatedRequest } = useAppContext()

  const projectsReportModal = useRef({})
  const investmentsReportModal = useRef({})
  const organizationsReportModal = useRef({})
  const distributionsReportModal = useRef({})
  const failedDistributionsReportModal = useRef({})

  const [ projects, setProjects ] = useState(null)

  useEffect(() => {
    if (projects) {
      return
    }

    return runRequest(() => {
      authenticatedRequest(listAllProjectsOperation)
        .then(({ data }) => setProjects(data))
    })
  }, [ projects, authenticatedRequest ])

  const openProjectsModal = () =>
    projectsReportModal.current.open()

  const openInvestmentsModal = () =>
    investmentsReportModal.current.open()

  const openDistributionsModal = ({ date }) =>
    distributionsReportModal.current.open(date)

  const openOrganizationsModal = ({ dateRange }) =>
    organizationsReportModal.current.open(dateRange)

  const openFailedDistributionsModal = () =>
    failedDistributionsReportModal.current.open()

  return (
    <>
      <Row gutter={[ W1, W1 ]}>
        <Col span={span}>
          <ReportCard
            title={LABEL_ORGANIZATIONS}
            summary={LABEL_ORGANIZATIONS_SUMMARY}
            onClick={openOrganizationsModal}
          />
        </Col>

        <Col span={span}>
          <ReportCard
            title={LABEL_PROJECTS}
            summary={LABEL_PROJECTS_SUMMARY}
            onClick={openProjectsModal}
          />
        </Col>

        <Col span={span}>
          <ReportCard
            title={LABEL_INVESTMENTS}
            summary={LABEL_INVESTMENTS_SUMMARY}
            onClick={openInvestmentsModal}
          />
        </Col>

        <Col span={span}>
          <ReportCard
            title={LABEL_DISTRIBUTIONS}
            summary={LABEL_DISTRIBUTIONS_SUMMARY}
            onClick={openDistributionsModal}
          />
        </Col>

        <Col span={span}>
          <ReportCard
            title={LABEL_FAILED_DISTRIBUTIONS}
            summary={LABEL_FAILED_DISTRIBUTIONS_SUMMARY}
            onClick={openFailedDistributionsModal}
          />
        </Col>
      </Row>

      <OrganizationsReportModal
        modal={organizationsReportModal}
      />

      <ProjectsReportModal
        modal={projectsReportModal}
        projects={projects}
      />

      <InvestmentsReportModal
        modal={investmentsReportModal}
        projects={projects}
      />

      <DistributionsReportModal
        modal={distributionsReportModal}
        projects={projects}
      />

      <FailedDistributionsReportModal
        modal={failedDistributionsReportModal}
      />
    </>
  )
}

ReportsList.propTypes = {
  span: PropTypes.number,
}

export default ReportsList
